import React from 'react';
import { GlobalContext } from '../shared/GlobalContext';
import * as utils from '../../shared/ClientUtils';

const LANGUAGE = 'en';

class AdvDocumentText extends React.Component {
  static contextType = GlobalContext;

  state = {};

  componentDidMount() {
    this.fetchBlobContents();
  }

  fetchBlobContents = () => {
    if (this.props.baseTag) {
      const tag = this.props.baseTag + '_' + LANGUAGE;
      utils.quickGet(
        '/api/data/document/one?tag=' + tag,
        {},
        utils.toastAlertFunc,
        'Error getting document for tag ' + tag + ': ',
        (j) => {
          this.setState({
            blobContents: !j.document ? null : j.document.contents,
          });
        }
      );
    } else if (this.props.mArticleId) {
      utils.quickGet(
        '/api/data/marticle/one',
        { mArticleId: this.props.mArticleId },
        utils.toastAlertFunc,
        'Error getting media article: ',
        (j) => {
          this.setState({
            blobContents: j.mArticle.blob,
          });
        }
      );
    }
  };

  saveBlobContents = (blobContents) => {
    if (this.props.baseTag) {
      const tag = this.props.baseTag + '_' + LANGUAGE;
      utils.quickPost(
        '/api/data/document/updateContentsForTag',
        { tag, contents: blobContents },
        utils.toastAlertFunc,
        'Error updating document: ',
        (j) => {
          this.setState({
            blobContents: j.error ? null : j.document.contents,
          });
        }
      );
    } else if (this.props.mArticleId) {
      utils.quickPost(
        '/api/data/marticle/update',
        { mArticleId: this.props.mArticleId, blob: blobContents },
        utils.toastAlertFunc,
        'Error updating media article: ',
        (j) => {
          this.setState({
            blobContents: j.mArticle.blob,
          });
        }
      );
    }
  };

  render() {
    return (
      <div>
        <div
          dangerouslySetInnerHTML={{
            __html: this.state.blobContents,
          }}
        />
        {this.context.user &&
          this.props.roles.some((role) =>
            this.context.user.roles.includes(role)
          ) && (
            <i
              className='fa fa-edit'
              style={{ cursor: 'pointer' }}
              onClick={(event) => {
                event.preventDefault();
                this.context.showEditorModal(
                  this.state.blobContents,
                  (blobContents) => this.saveBlobContents(blobContents)
                );
              }}
            />
          )}
      </div>
    );
  }
}
export default AdvDocumentText;
